import React from 'react';
import {
    Page,
    Layout,
    Card,
    MediaCard,
    VideoThumbnail
} from '@shopify/polaris';
import { Helmet } from 'react-helmet';

class Tutorials extends React.Component {

    render() {

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Tutorials</title>
                </Helmet>
                <Page title="Tutorials"
                    subtitle="Videos that can help you get started with Tag Genie.">
                    <Layout>
                        <Layout.Section>
                            <Card title="Videos">
                                <Card.Section>
                                    <MediaCard
                                        title="Overview of Features"
                                        primaryAction={{
                                            content: 'Learn more',
                                            onAction: () => { this.redirectToUrl("https://youtu.be/jhJKTmZN6o8") },
                                        }}
                                        description={`Learn how to Bulk remove single or multiple tags with ease.`}
                                    >
                                        <VideoThumbnail
                                            videoLength={624}
                                            thumbnailUrl="https://taggenie.azureedge.net/images/video-header.png"
                                            onClick={() => this.redirectToUrl("https://youtu.be/jhJKTmZN6o8")}
                                        />
                                    </MediaCard>
                                    <MediaCard
                                        title="Bulk Remove Tags"
                                        primaryAction={{
                                            content: 'Learn more',
                                            onAction: () => { this.redirectToUrl("https://www.youtube.com/watch?v=22-y6Mo__gI") },
                                        }}
                                        description={`Learn how to Bulk remove single or multiple tags with ease.`}
                                    >
                                        <VideoThumbnail
                                            videoLength={230}
                                            thumbnailUrl="https://taggeniemain.blob.core.windows.net/images/featured-bulk-tag-remove.png"
                                            onClick={() => this.redirectToUrl("https://www.youtube.com/watch?v=22-y6Mo__gI")}
                                        />
                                    </MediaCard>
                                    <MediaCard
                                        title="Bulk Merge/Rename Tags"
                                        primaryAction={{
                                            content: 'Learn more',
                                            onAction: () => { this.redirectToUrl("https://youtu.be/YW8ZGTRqwg8") },
                                        }}
                                        description={`Learn how to Bulk rename or merge tags with just a few clicks.`}
                                    >
                                        <VideoThumbnail
                                            videoLength={252}
                                            thumbnailUrl="https://taggenie.azureedge.net/images/blog-merge-rename-cover.png"
                                            onClick={() => this.redirectToUrl("https://youtu.be/YW8ZGTRqwg8")}
                                        />
                                    </MediaCard>
                                    <MediaCard
                                        title="Prefix Tags"
                                        primaryAction={{
                                            content: 'Learn more',
                                            onAction: () => { this.redirectToUrl("https://youtu.be/8hNAOhFZWow") },
                                        }}
                                        description={`Learn how to prefix tags using Custom Tag Operation and tokens.`}
                                    >
                                        <VideoThumbnail
                                            videoLength={352}
                                            thumbnailUrl="https://taggenie.azureedge.net/images/blog-prefix-tags-cover.png"
                                            onClick={() => this.redirectToUrl("https://youtu.be/8hNAOhFZWow")}
                                        />
                                    </MediaCard>
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div>
        );
    }

    redirectToUrl = (url) => {
        window.open(url, '_blank');
    }

    onFacebookClick = () => {

    }

    componentDidMount() {

    }
}

export default Tutorials;